import React, { useEffect } from "react";
import "./Develop.css";
import devImg from "../../../Images/software_development.svg";
import Devcard from "./Devcard/Devcard";
import ScrollMagic from "scrollmagic";

const Developpage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const controller = new ScrollMagic.Controller();

    const triggerElement = document.getElementById("triggerPinned");

    if (window.innerWidth > 768 && triggerElement) {
      new ScrollMagic.Scene({
        triggerElement: triggerElement,
        triggerHook: 0,
      })
        .setPin(triggerElement)
        .addTo(controller);
    }

    return () => controller.destroy();
  }, []);
  return (
    <div>
      <div className="banner-contenten-dev" id="triggerPinned">
        <div className="left-container">
          <h1>Mobile App & Website Development</h1>
        </div>
      </div>
      <div className="white-section" style={{ position: "relative", zIndex: "1" }}>
        <div className="about-dev-content">
          <div className="left-about-content">
            <h1>Your technology partner</h1>
            <p>
              Stepping into the world of software development can feel overwhelming, especially when
              faced with complex decisions and uncertainties. At Owision, we make the process simple
              and efficient. We offer our clients the needed expertise, paired with transparent
              deadlines and deliverables, turning your vision into a reliable digital product. With
              us, software development becomes less about guesswork and more about results.
            </p>
          </div>
          <div className="right-about-content">
            <img src={devImg} alt="dev img" />
          </div>
        </div>
        <Devcard />
      </div>
    </div>
  );
};

export default Developpage;
